import { useTranslation } from "react-i18next";

import Icons from "@/components/icons";
import { ROUTES } from "@/constants/routes";
import { useModuleStatus } from "@/features/integrations/api/useModuleStatus";
import { useAuth } from "@/lib/hooks/useAuth";
import { SidebarItem as NavigationItem } from "@/types/sidebar/SidebarProps";
import { UserRole as USER_ROLES } from "@/types/user/userType";

const useAdminRoutes = () => {
  const { t } = useTranslation();
  const { role } = useAuth();
  const { data: moduleStatus } = useModuleStatus("applies");
  const items: NavigationItem[] = [
    {
      path: ROUTES.clients,
      icon: Icons.ClientsIcon,
      label: t("routes.admin.clients"),
    },
  ];

  // Add user management for admins only
  if (role === USER_ROLES.SUPER_ADMIN || role === USER_ROLES.ADMIN) {
    items.push({
      path: ROUTES.users,
      icon: Icons.ManageUserIcon,
      label: t("routes.admin.users"),
    });
  }

  if (role === USER_ROLES.SUPER_ADMIN) {
    items.push(
      ...[
        {
          path: `/${ROUTES.integrations}`,
          icon: Icons.AssignIcon,
          label: t("common.integrations"),
        },
      ]
    );
  }

  if (moduleStatus?.enabled) {
    items.push({
      path: `/${ROUTES.applies}`,
      icon: Icons.ApplyIcon,
      label: t("routes.admin.applies"),
    });
  }

  items.push(
    ...[
      {
        path: `/${ROUTES.invoices}`,
        icon: Icons.CurrencyIcon,
        label: t("routes.admin.invoices"),
      },
      {
        path: `/${ROUTES.insights}`,
        icon: Icons.BarChartIcon,
        label: t("routes.admin.insights"),
      },
    ]
  );

  return { items };
};

export { useAdminRoutes };
